"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Link = /** @class */ (function () {
    function Link(data) {
        Object.assign(this, data);
    }
    return Link;
}());
exports.Link = Link;
//# sourceMappingURL=link.class.js.map